import React, {useEffect, useState} from "react";
import {Col, InputNumber, Select} from "antd";
import _ from "lodash";
import {
    CityFilter,
    CompanyFilter,
    CourierTypeFilter,
    SubCompanyFilter,
    PoolFilter,
} from "../../_defaultComponents/FilterComponents";
import {usePoolCompanies} from "../../../hooks/usePoolCompanies";
import {EligibleCourierSelect} from "../../_defaultComponents/EligibleCourierSelect/EligibleCourierSelect";
import {useTranslation} from "react-i18next";
import {courierStatusColors, courierStatuses} from "../../../constants/constants";
import {useStore} from "../../../hooks/useStore";

const Filters = ({setCurrentPage, filters, setFilters, data = [], dataLoading = false}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [filterState, setFilterState] = useState({
        city: filters.city,
        companyId: filters.companyId,
        subcompanyId: filters.subCompanyId,
        courierType: filters.courierType,
        preferredCourierId: filters.preferredCourierId,
        forceCourierId: filters.forceCourierId,
        pool: filters.pool,
        distance: filters.distance
    });
    const { filterCompany, isLoading } = usePoolCompanies(filterState.pool);
    useEffect(() => {
        if (filterState.pool) {
            setFilterState(prev => ({
                ...prev,
                companyId: undefined,
                subcompanyId: undefined,
                preferredCourierId: undefined,
                forceCourierId: undefined
            }));
        }
    }, [filterState.pool]);
    useEffect(() => {
        if (JSON.stringify(filters) !== JSON.stringify(filterState)) {
            setFilters(filterState);
            setCurrentPage(1);
        }
    }, [JSON.stringify(filterState)]);

    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={4} xl={3}>
                <CityFilter
                    showAllOption={false}
                    value={filters.city}
                    allowClear={true}
                    onChange={value =>
                        setFilterState({
                            ...filterState,
                            city: value,
                            pool: undefined,
                            companyId: undefined,
                            subcompanyId: undefined,
                        })
                    }
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={3}>
                <PoolFilter
                    showAllOption={false}
                    value={filters.pool}
                    allowClear={true}
                    city={filters.city}
                    onChange={value =>
                        setFilterState({
                            ...filterState,
                            pool: value,
                        })
                    }
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <CompanyFilter
                    showAllOption={false}
                    showPoolOption={false}
                    value={filterState.companyId}
                    city={filters.city}
                    onChange={value => {
                        setFilterState({
                            ...filterState,
                            companyId: value,
                            subcompanyId: undefined,
                            forceCourierId: undefined,
                            preferredCourierId: undefined,
                            courierType:
                                stores?.appStore?.companyListFilter?.find(c => c._id === value)
                                    ?.courierTypes?.[0] || undefined
                        });
                    }}
                    optionFilter={filterCompany}
                    loading={isLoading}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={5}>
                <SubCompanyFilter
                    company={filterState.companyId}
                    city={filterState.city}
                    value={filterState.subcompanyId}
                    onChange={value => {
                        setFilterState({
                            ...filterState,
                            subcompanyId: value,
                            forceCourierId: undefined,
                            preferredCourierId: undefined
                        });
                    }}
                    disabled={!filterState.companyId}
                    initialCall={false}
                    showAllOption={false}
                    allowClear={false}
                    showSearch={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={2}>
                <CourierTypeFilter
                    value={filterState.courierType}
                    onChange={value => {
                        setFilterState({
                            ...filterState,
                            courierType: value,
                            forceCourierId: undefined,
                            preferredCourierId: undefined
                        });
                    }}
                    disabled={!filterState.companyId}
                    allowClear={false}
                    showAll={false}
                    hideTitle={false}
                    filterOnly={
                        stores.appStore.companyListFilter.find(c => c._id === filterState.companyId)
                            ?.courierTypes || []
                    }
                />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
